import { render } from "./RoomsListPage.vue?vue&type=template&id=2f9ae3c3&ts=true"
import script from "./RoomsListPage.vue?vue&type=script&lang=ts"
export * from "./RoomsListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__